import api from "./api";

// Capa de servicios API del dominio "listas de archivos" (files) (FSD / capa API transversal).
// Wrappers de transporte finos: la construcción de payloads/params vive en el
// componente; aquí solo se centraliza el endpoint (un único lugar que tocar si cambia).
// Nota: los endpoints /vps/files/* son del dominio "vps" (monitoreo), no de este.

// --- CRUD de listas ---
export const listFiles = (params) => api.get("/files/", { params });
export const findFileListById = (fileListId) => api.get(`/files/${fileListId}`);
export const createFileList = (payload) => api.post("/files", payload);
export const updateFileList = (fileListId, payload) =>
  api.put(`/files/${fileListId}`, payload);
export const deleteFileList = (fileListId) => api.delete(`/files/${fileListId}`);

// --- Archivos dentro de una lista ---
export const uploadFileListMedia = (fileListId, formData) =>
  api.post(`/files/uploadList/${fileListId}`, formData);
export const deleteFileOption = (fileListId, optionId) =>
  api.delete(`/files/${fileListId}/options/${optionId}`);

// --- Subida individual (usada por campañas de grupo) ---
export const uploadSingleFile = (formData) =>
  api.post("/files/upload-single", formData);
